export default __webpack_public_path__ + "static/media/Belt of the Sanguine Disciple (nm).f8037902.jpg";